<template>
  <StateAnalysis title="健康评价报告" report="jkReportHistories"></StateAnalysis>
</template>

<script>
import StateAnalysis from "./state.vue";
export default {
  components: {
    StateAnalysis,
  },
  computed: {},
  methods: {},
};
</script>

<style >
</style>